import { BaseRequests } from "../../../config/BaseRequests";
import { revenueApiEndpoints } from "../api/revenue.api";
import {
  RevenueSetting,
  RevenueStats,
  UpdateRevenueSettingDto,
} from "../dto/index.dto";

export class RevenueService {
  static getSettings = (): Promise<RevenueSetting[]> =>
    BaseRequests.get(revenueApiEndpoints.getSettings);

  static updateSetting = (
    type: string,
    data: UpdateRevenueSettingDto
  ): Promise<RevenueSetting> =>
    BaseRequests.patch(revenueApiEndpoints.updateSetting(type), data);

  static getStats = (): Promise<RevenueStats> =>
    BaseRequests.get(revenueApiEndpoints.getStats);
}
